import React, { createContext, useState } from "react";
export const AddApplicationContext = createContext();

export const AddApplicationContextProvider = ({ children }) => {
  const [currentStep, setStep] = useState(1);
  const [applicationId, setApplicationId] = useState(null);

  const [stepDetails, setStepDetails] = useState({
    programDetails: null,
    educationDetails: { highSchool: null, postHighSchool: null },
    gradeDetails: null,
    contactDetails: null,
    extraInformation: null,
    submissionDetails: null,
    programApplicationFee: null,
    programApplicationNumber: null,
    paymentComplete: false,
  });

  const [stepsCompleteStatus, setStepsCompletedStatus] = useState({
    step1: false,
    step2: false,
    step3: false,

    step4: false,
  });

  return (
    <>
      <AddApplicationContext.Provider
        value={{
          currentStep,
          setStep,
          applicationId,
          setApplicationId,
          stepDetails,
          setStepDetails,
          stepsCompleteStatus,
          setStepsCompletedStatus,
        }}
      >
        {children}
      </AddApplicationContext.Provider>
    </>
  );
};
